import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { selectCatalog } from '../root-store/catalog-store/selectors';
import { RootState } from '../root-store/root-state.model';
import { selectOrderIdQueryString, selectOrderIdStatusPage } from '../root-store/router/selectors';
import { BackendService } from './backend.service';

const keepAliveUrl = '/api/Cart/KeepAlive'

// Set CatalogId HTTP-Param
export function webApiInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  const store = inject(Store<RootState>)
  const backend = inject(BackendService)
  const snackbar = inject(MatSnackBar)
  const translate = inject(TranslateService)

  const catId = store.selectSignal(selectCatalog)()?.id

  if (!catId)
    return next(req)

  let modified = req.params.has('CatalogId') || req.url.startsWith('assets/') ? req : req.clone({
    // set CatalogId as QueryString (HttpHeader would be nicer, but causes caching issues in GoogleBot)
    setParams: {
      CatalogId: catId.toString()
    }
  })

  if (modified.method !== 'GET')
    modified = modified.clone({
      setHeaders: {
        'RequestVerificationToken': backend.requestVerificationToken!
      }
    })

  // optionally add OrderId-Param on requests to /api/Cart, if specified in QueryString (except for /KeepAlive)
  if (!modified.params.has('OrderId')) {
    if (req.url.includes('/api/Cart') && !req.url.includes(keepAliveUrl)) {
      const orderIdQueryString = store.selectSignal(selectOrderIdQueryString)()
      const orderIdRouteParam = store.selectSignal(selectOrderIdStatusPage)()

      if (orderIdQueryString)
        modified = modified.clone({ setParams: { OrderId: orderIdQueryString } })
      else if (orderIdRouteParam)
        modified = modified.clone({ setParams: { OrderId: orderIdRouteParam } })
    }
  }

  return next(modified).pipe(
    // handle Response-Errors
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        let message: string = error.error?.toString()

        // If anti-forgery token is invalid, show an understandable message and reload the page
        if (message?.includes('XSRF')) {
          message = translate.instant(_('ERROR.XSRF_DIFFERENT_USER'))

          if (modified.url.includes(keepAliveUrl))
            document.location.reload()
        }

        if (message)
          snackbar.open(message)
      }

      return throwError(() => error)
    })
  )
}
